import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref, computed, onMounted, reactive, toRefs } from "vue";
import debounce from "lodash/debounce"; // export default defineComponent({})

export default /*#__PURE__*/_defineComponent({
  props: {
    bgColor: {
      type: String,
      required: false,
      default: "#d33a30"
    },
    percentage: {
      type: Number,
      required: true
    }
  },
  emits: ["change-percentage", "change-darging-state"],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
        emits = _ref.emit;
    expose();
    var props = __props;

    var _toRefs = toRefs(props),
        percentage = _toRefs.percentage;

    var playbackRef = ref();
    /** 进度条元素 */

    var dragBtnDisplay = ref(false);
    /** 进度条拖拽按钮是否显示 */

    var dragState = reactive({
      innerPercentage: null,
      dragging: false
      /** 是否正在拖拽进度条 */
      ,
      startX: 0
      /** 记录最开始点击的X轴坐标 */

    });
    var currentPercentage = computed(function () {
      if (dragState.innerPercentage === null) {
        return percentage.value;
      }

      return dragState.innerPercentage;
    });
    /** 切换拖拽按钮是否展示 */

    var toggleDragBtnDisplay = function toggleDragBtnDisplay(isDisplay) {
      dragBtnDisplay.value = isDisplay;

      if (!isDisplay) {
        /** 鼠标移出之前正在拖拽则触发 */
        if (dragState.dragging) {
          emits("change-darging-state", false);
        }
        /** 停止拖拽时，把拖拽时的进度置空，使用外部传入的进度 */


        dragState.dragging = false;
        dragState.innerPercentage = null;
      }
    };

    var handleProgressChange = debounce(function () {
      var _playbackRef$value, _playbackRef$value2;

      var endX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var isDraging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var withPercentage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      /** 获取进度条的长度 */
      var eleWidth = (_playbackRef$value = playbackRef.value) === null || _playbackRef$value === void 0 ? void 0 : _playbackRef$value.getBoundingClientRect().width;
      var eleToLeft = (_playbackRef$value2 = playbackRef.value) === null || _playbackRef$value2 === void 0 ? void 0 : _playbackRef$value2.getBoundingClientRect().left;
      /** 计算鼠标距离进度条底部的百分比 */

      var percent = (endX - eleToLeft) / eleWidth * 100;

      if (percent > 100) {
        percent = 100;
      } else if (percent < 0) {
        percent = 0;
      }

      dragState.dragging = isDraging;

      if (isDraging) {
        dragState.innerPercentage = percent;
      } else {
        dragState.innerPercentage = null;
      }

      if (!withPercentage) {
        emits("change-percentage", percent / 100);
      } else {
        emits("change-percentage", percent / 100, percent / 100);
      }
    }, 10);

    var handleDragStart = function handleDragStart(e) {
      if (e instanceof TouchEvent) {
        dragState.startX = e.changedTouches[0].clientX;
      } else {
        dragState.startX = e.clientX;
      }

      handleProgressChange(dragState.startX); // 为元素添加鼠标移动和松开事件

      window.addEventListener("mousemove", handleOnDrag);
      window.addEventListener("touchmove", handleOnDrag);
      window.addEventListener("mouseup", handleDragEnd);
      window.addEventListener("touchend", handleDragEnd);
    };

    var handleOnDrag = function handleOnDrag(e) {
      if (!dragState.dragging) {
        return false;
      }
      /** 获取进度条到浏览器的距离 */


      var endX = 0;

      if (e instanceof TouchEvent) {
        endX = e.changedTouches[0].clientX;
      } else {
        endX = e.clientX;
      }

      handleProgressChange(endX);
    };

    var handleDragEnd = function handleDragEnd(e) {
      /** 获取进度条到浏览器的距离 */
      var endX = 0;

      if (e instanceof TouchEvent) {
        endX = e.changedTouches[0].clientX;
      } else {
        endX = e.clientX;
      }

      handleProgressChange(endX, false, true);
      /** 移除事件监听 */

      window.removeEventListener("mousemove", handleOnDrag);
      window.removeEventListener("touchmove", handleOnDrag);
      window.removeEventListener("mouseup", handleDragEnd);
      window.removeEventListener("touchend", handleDragEnd);
    };

    var moveHandler = function moveHandler(e) {
      if (e.type === "mousedown" || e.type === "touchstart") {
        handleDragStart(e);
      } else if (e.type === "mousemove" || e.type === "touchmove") {
        handleOnDrag(e);
      } else if (e.type === "mouseup" || e.type === "touchend") {
        handleDragEnd(e);
      }
    };

    onMounted(function () {
      var _playbackRef$value3;

      (_playbackRef$value3 = playbackRef.value) === null || _playbackRef$value3 === void 0 ? void 0 : _playbackRef$value3.addEventListener("mousedown", moveHandler);
    });
    var __returned__ = {
      props: props,
      emits: emits,
      percentage: percentage,
      playbackRef: playbackRef,
      dragBtnDisplay: dragBtnDisplay,
      dragState: dragState,
      currentPercentage: currentPercentage,
      toggleDragBtnDisplay: toggleDragBtnDisplay,
      handleProgressChange: handleProgressChange,
      handleDragStart: handleDragStart,
      handleOnDrag: handleOnDrag,
      handleDragEnd: handleDragEnd,
      moveHandler: moveHandler
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});